import { Route } from 'react-router-dom'
import { Navigate } from 'react-router-dom'

import GuestMiddleware from '../middlewares/GuestMiddleware'

import PageSignIn from '../pages/auth/PageSignIn'
import PageYandexCallback from '../pages/auth/PageYandexCallback'

import PageDocuments from '../pages/static/Terms/PageDocuments';
import PrivacyPage from '../pages/static/Terms/PagePrivacy';
import TermsOfServicePage from '../pages/static/Terms/PageTermsOfServices';
import CookiesPage from '../pages/static/Terms/PageCookies';
import DataProcessingPage from '../pages/static/Terms/PageDataProcessing';
import PageSupport from '../pages/static/Support/PageSupport';
import PageFAQ from '../pages/static/FAQ/PageFAQ';
import PageWelcome from '../pages/static/Welcome/PageWelcome';
import PageChildSafety from '../pages/static/Terms/PageChildSafety'
import { ExternalRedirect, FileDownload } from '../pages/static/Apps/Download'

export const RoutesAuth = [
    <Route index element={<Navigate to="/feed" replace />} key="route-redirect-main" />,
    <Route path="/auth" element={<GuestMiddleware><PageSignIn /></GuestMiddleware>} key="route-auth" />,
    <Route path="/auth/yandex" element={<PageYandexCallback />} key="route-auth-yandex" />,

    <Route path="/legal" element={<PageDocuments />} key="route-terms" />,
    <Route path="/legal/privacy" element={<PrivacyPage />} key="route-terms-privacy" />,
    <Route path="/legal/terms-of-service" element={<TermsOfServicePage />} key="route-terms-terms-of-service" />,
    <Route path="/legal/data-processing" element={<DataProcessingPage />} key="route-terms-data-processing" />,
    <Route path="/legal/cookies" element={<CookiesPage />} key="route-terms-cookies" />,
    <Route path="/legal/child-safety" element={<PageChildSafety />} key="route-terms-child-safety" />,

    <Route path="/support" element={<PageSupport />} key="route-support" />,
    <Route path="/faq" element={<PageFAQ />} key="route-support" />,
    <Route path="/welcome" element={<PageWelcome />} key="route-welcome" />,

    <Route path="/download/ios" element={<ExternalRedirect to="https://apps.apple.com/us/app/аквариум-мессенджер-и-блог/id6771532179" />} key="route-download-ios" />,
    <Route path="/download/android" element={<FileDownload href="/android/aquarium.apk" />} key="route-download-android" />,
    // Адрес с расширением: на него ведёт «Прямая ссылка» со страницы /apps, а файла
    // по нему нет — nginx отдавал SPA-фолбэк, то есть HTML вместо APK.
    <Route path="/download/android.apk" element={<FileDownload href="/android/aquarium.apk" />} key="route-download-android-apk" />,
]
